import styled from 'styled-components';
import { TableResponsiveMixin } from '../../mixins/components/TableResponsiveMixin';
export var StyledTableResponsive = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTableResponsive",
  componentId: "c11n-8-107-0__sc-goovyt-0"
})(["", ""], TableResponsiveMixin);